<template>
  <v-row class="ml-1 mb-4 align-center">
    <v-icon size="24" class="text-small primary--text">{{ icon }}</v-icon>
    <h3 class="ml-2 text-small primary--text">
      {{ title }}
    </h3>

    <v-spacer></v-spacer>

    <span
      class="mx-8 subtitle-right text-caption primary--text "
      v-if="breadcrumb"
    >
      <span v-for="(part, index) in breadcrumbParts" :key="'part-' + index">
        <span v-if="index < breadcrumbParts.length - 1">{{ part }} / </span>
        <strong v-else>{{ part }}</strong>
      </span>
    </span>
  </v-row>
</template>

<script>
export default {
  name: "BaseBreadcrumb",
  props: {
    title: String,
    icon: String,
    breadcrumb: String
  },
  computed: {
    breadcrumbParts() {
      return this.breadcrumb.split(" / ");
    }
  }
};
</script>

<style>
@media (max-width: 465px) {
  .text-small {
    font-size: 1.1rem !important;
    line-height: 2rem;
  }
  .text-small svg {
    height: 24px !important;
    width: 24px !important;
  }
}

.subtitle-right {
  font-weight: 400;
  opacity: 0.7;
}
</style>
